import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';

import { UserConfigs } from '../models/user-configs.model';
import { UserConfigsService } from '../services/user-configs.service';
import { UserProfileService } from '../services/user-profile.service';

@Injectable({
	providedIn: 'root'
})
export class UserProfileGuard  {

	constructor(
		private readonly router: Router,
		private readonly userConfigsService: UserConfigsService,
		private readonly userProfileService: UserProfileService
	) { }

	canActivate(): Observable<boolean | UrlTree> {
		return this.userConfigsService.getUserConfigs().pipe(
			take(1),
			mergeMap((userConfig: UserConfigs) => this.userProfileService.isUserProfileComplete(userConfig.userId)
				.pipe(
					map(((userProfileComplete: boolean) => {
						if (!userConfig.currentCase)
							return this.router.createUrlTree(['/select-case'], { queryParams: { suppressMenu: 'true' } });

						return userProfileComplete ?
							true :
							this.router.createUrlTree(['/user/profile'], { queryParams: { suppressMenu: 'true' } })
					}))
				)));
	}
}
